export default "__VITE_ASSET__CtibVv2B__"